import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { IconHeaderError } from 'components/Icons'
import { CenterContent, SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<CenterContent>
			<SplashScreen
				title={
					<FormattedMessage id='notAuthenticated.title' defaultMessage='You must be logged in to access this page.' />
				}
				icon={<IconHeaderError />}
			/>
		</CenterContent>
	),
})
